export default function removeEmptyRefunds(transaction) {
  let refunds = [];
  transaction.refunds.forEach((refund) => {
    if (refund.created === 0 || refund.amount === 0) return;
    refunds.push(refund);
  });
  return refunds;
}
